export default __webpack_public_path__ + "static/media/joe_rotella.0f1458cf.jpg";